import { render, staticRenderFns } from "./ArticleNewBadge.vue?vue&type=template&id=319898be&scoped=true&"
import script from "./ArticleNewBadge.vue?vue&type=script&lang=ts&"
export * from "./ArticleNewBadge.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleNewBadge.vue?vue&type=style&index=0&id=319898be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319898be",
  null
  
)

export default component.exports